export default function RestaurantsSection() {
  return (
    <section id="restaurants" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">

          {/* Images first on mobile */}
          <div className="relative lg:order-2">
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="rounded-xl md:rounded-2xl overflow-hidden">
                <div className="h-52 md:h-72 w-full">
                  <img
                    src="https://storage.readdy-site.link/project_files/2a3103c6-bc18-4dd1-9f88-ff451204a703/809b2a13-ce9e-469d-b95e-5ee3c59e19cf_4101775054118_.pic_hd.jpg?v=374b7c830585323de72c24272ba46085"
                    alt="花木流味噌 五反野店"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 md:gap-4">
                <div className="rounded-xl md:rounded-2xl overflow-hidden">
                  <div className="h-36 md:h-56 w-full">
                    <img
                      src="https://storage.readdy-site.link/project_files/2a3103c6-bc18-4dd1-9f88-ff451204a703/6b30f46c-e60b-4665-9056-840686bc41d7_4111775054119_.pic_hd.jpg?v=bc5a359f5a3792380eabcbb6f8be744c"
                      alt="花木流味噌 五反野店"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="rounded-xl md:rounded-2xl overflow-hidden">
                  <div className="h-36 md:h-56 w-full">
                    <img
                      src="https://storage.readdy-site.link/project_files/2a3103c6-bc18-4dd1-9f88-ff451204a703/361a5780-82cf-44ce-b613-34fa4d72088e_4121775054120_.pic_hd.jpg?v=a60b4310c29549b2588c8f55bcfaee1e"
                      alt="花木流味噌 五反野店"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text info */}
          <div className="lg:order-1">
            <div className="inline-block bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-xs font-medium mb-3 md:mb-6">
              自社運営
            </div>
            <h2 className="text-2xl md:text-5xl font-bold text-slate-800 mb-3 md:mb-6 leading-tight">
              花木流味噌 五反野店
            </h2>
            <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-5 md:mb-8">
              東京・五反野に佇む味噌ラーメン専門店。厳選した味噌と豊かなスープで、こだわりの一杯をご提供しています。温かみのある空間で、特別なひとときをお過ごしください。
            </p>

            <div className="space-y-3 md:space-y-6 mb-5 md:mb-8">
              {[
                { icon: 'ri-leaf-line', title: '季節の食材', text: '旬の食材を厳選し、素材本来の味を最大限に引き出します' },
                { icon: 'ri-user-star-line', title: '熟練の技', text: '長年の経験を持つ料理人が、一品一品丁寧に仕上げます' },
                { icon: 'ri-home-heart-line', title: '心地よい空間', text: '和の趣を感じる落ち着いた雰囲気で、ゆったりとお食事を楽しめます' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 md:gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-lg md:text-2xl text-teal-700`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm md:text-lg font-semibold text-slate-800 mb-0.5 md:mb-2">{item.title}</h4>
                    <p className="text-xs md:text-base text-gray-600">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-slate-50 rounded-xl md:rounded-2xl p-4 md:p-6">
              <h4 className="text-sm md:text-lg font-semibold text-slate-800 mb-3 md:mb-4">店舗情報</h4>
              <div className="space-y-2 md:space-y-3 text-gray-700">
                <p className="flex items-start gap-2 md:gap-3 text-xs md:text-base">
                  <i className="ri-map-pin-line text-teal-600 mt-0.5"></i>
                  <span>〒120-0015 東京都足立区足立2丁目（五反野エリア）</span>
                </p>
                <p className="flex items-center gap-2 md:gap-3 text-xs md:text-base">
                  <i className="ri-phone-line text-teal-600"></i>
                  <span>TEL: 050-1720-6460</span>
                </p>
                <p className="flex items-center gap-2 md:gap-3 text-xs md:text-base">
                  <i className="ri-smartphone-line text-teal-600"></i>
                  <span>Mobile: 080-1133-6460</span>
                </p>
                <p className="flex items-center gap-2 md:gap-3 text-xs md:text-base">
                  <i className="ri-mail-line text-teal-600"></i>
                  <span>hawa0816@yahoo.co.jp</span>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
